import { render, staticRenderFns } from "./AdminAnnonces.vue?vue&type=template&id=ae526118&scoped=true"
import script from "./AdminAnnonces.vue?vue&type=script&lang=js"
export * from "./AdminAnnonces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae526118",
  null
  
)

export default component.exports